import { helpers } from '@/helpers/index.ts';

const backendHeaders = (token?: string) =>
  token
    ? {
        Authorization: `Bearer ${token}`,
      }
    : {};

/* eslint-disable @typescript-eslint/no-explicit-any */
const backendApis = {
  addBrowserTaskLogRecord: async (params: any, token: string) => {
    return helpers.api.post({
      data: params,
      headers: backendHeaders(token),
      url: `/agent/add_browser_task_log_record`,
    });
  },
  agentCredentialsShape: async (params: any) => {
    return helpers.api.post({
      data: params,
      url: `/agent/credentials/shape`,
    });
  },
  browserStateExists: async (params: any) => {
    return helpers.api.post({
      data: params,
      url: '/agent/browser_state/exists',
    });
  },
  usersList: async (params: any = {}, headers: any = {}) => {
    return helpers.api.post({
      data: params,
      headers,
      url: '/user/list',
    });
  },
  userProfile: async (params: any = {}, headers: any = {}) => {
    return helpers.api.post({
      data: params,
      url: '/user/get',
    });
  },
  cancelWorkflowRun: async (params: any) => {
    return helpers.api.post({
      data: params,
      url: '/cancel_workflow_run',
    });
  },
  carrierEnterOtp: async (params: any) => {
    return helpers.api.post({
      data: params,
      url: '/agent/carrier_connect/enter_otp',
    });
  },
  carrierRetryPage: async (params: any) => {
    return helpers.api.post({
      data: params,
      url: '/agent/carrier_connect/retry',
    });
  },
  createCarrierConnection: async (params: any) => {
    return helpers.api.post({
      data: params,
      url: '/agent/carrier_connect/create',
    });
  },
  createSecret: async (params: any) => {
    return helpers.api.post({
      data: params,
      url: `/agent/credentials/create`,
    });
  },
  createWorkflowRun: async (params: any) => {
    return helpers.api.post({
      data: params,
      url: '/create_workflow_run',
    });
  },
  deleteSecret: async (params: any) => {
    return helpers.api.post({
      data: params,
      url: `/agent/credentials/delete`,
    });
  },
  getBrowserRunMockQuestions: async (params: any, token: string) => {
    return helpers.api.post({
      data: params,
      headers: backendHeaders(token),
      url: `/agent/browser_run/get_mock_questions`,
    });
  },
  getBrowserRunQuestions: async (params: any, token?: string) => {
    return helpers.api.post({
      data: params,
      headers: backendHeaders(token),
      url: `/agent/browser_run/get_questions`,
    });
  },
  getBrowserRunScreenshot: async (params: any, token: string) => {
    return helpers.api.post({
      data: params,
      headers: backendHeaders(token),
      url: `/agent/browser_run/get_session_image_download_url`,
    });
  },
  getBrowserRunsBatch: async (params: any) => {
    return helpers.api.post({
      data: params,
      url: `/agent/browser_run/get_batch`,
    });
  },
  getBrowserState: async (params: any) => {
    return helpers.api.post({
      data: params,
      url: '/agent/get_browser_state',
    });
  },
  getDocumentDownloadUrl: async (params: any) => {
    return helpers.api.post({
      data: params,
      url: '/get_document_download_url',
    });
  },
  getDocumentUrl: async (params: any) => {
    return helpers.api.post({
      data: params,
      url: `/document_upload_url`,
    });
  },
  getOrganization: async (params: any) => {
    return helpers.api.post({
      data: params,
      url: `/organization/get`,
    });
  },
  getWorkflowById: async (params: any) => {
    return helpers.api.get({
      params,
      url: `/get_workflow`,
    });
  },
  getWorkflowLog: async (params: any) => {
    return helpers.api.get({
      params,
      url: `/get_workflow_log`,
    });
  },
  get_document_metadata: async (params: any) => {
    return helpers.api.post({
      data: params,
      url: `/get_document_metadata`,
    });
  },
  get_document_pages: async (params: any) => {
    return helpers.api.post({
      data: params,
      url: `/get_document_page_urls`,
    });
  },
  ingestDocuments: async (params: any) => {
    return helpers.api.post({
      data: params,
      url: '/ingest_documents',
    });
  },
  interact: async (params: any, token: string) => {
    return helpers.api.post({
      data: params,
      headers: backendHeaders(token),
      url: `/interact`,
    });
  },
  listWorkflowRuns: async (params: any) => {
    return helpers.api.get({
      params,
      url: '/list_workflow_runs',
    });
  },
  getWorkflowRunObject: async (params: any) => {
    return helpers.api.get({
      params,
      url: '/get_workflow_run_object',
    });
  },
  listWorkflows: async (params: any = {}) => {
    return helpers.api.get({
      params,
      url: '/list_workflows',
    });
  },
  secretExists: async (params: any) => {
    return helpers.api.post({
      data: params,
      url: `/agent/credentials/exist`,
    });
  },
  getCarrierAccessVerification: async (params: any) => {
    return helpers.api.post({
      data: params,
      url: '/get_carrier_access_verification',
    });
  },
  getCarrierAccessLiveLinks: async (params: any) => {
    return helpers.api.get({
      params,
      url: '/get_carrier_access_live_links',
    });
  },
  isCarrierAccessVerificationRunning: async (params: any) => {
    return helpers.api.get({
      params,
      url: '/is_carrier_access_verification_running',
    });
  },
};

export default backendApis;
